import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { TypesEventClient } from './types';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.TipoEventoQuery],
  create: [SystemAuthorizations.TipoEventoAdd],
  edit: [SystemAuthorizations.TipoEventoUpdate],
  delete: [SystemAuthorizations.TipoEventoDelete],
});

export const validationSchemaTypesEventFilterForm = yup.object({
  code: yup.number().nullable().notRequired(),
  description: yup.string().nullable().notRequired(),
});

export const headCells: HeadCell<TypesEventClient, keyof TypesEventClient>[] = [
  {
    id: 'codice',
    label: 'Codice',
  },
  {
    id: 'descrizione',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];
